import React, { useState, useEffect } from 'react';
import { PlusIcon, TrashIcon, PencilIcon, CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { APIURL } from '../../configApi/apiConfig';
import axios from "../../configApi/axiosConfig";
export default function TablaAccionesCobranzas({
    acciones,
    loading,
    estrategiaSeleccionada,
    onAgregar,
    onEditar,
    onEliminar
}) {
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [accionesDisponibles, setAccionesDisponibles] = useState([]);
    const [mensajesDisponibles, setMensajesDisponibles] = useState([]);
    const [errores, setErrores] = useState({});


    const [formData, setFormData] = useState({
        idCbo_AccionesCobranzas: '',
        sCbo_FlujoDeCobranzas: estrategiaSeleccionada?.sCbo_FlujoDeCobranzas || '',
        idCbo_FlujoDeCobranzas: estrategiaSeleccionada?.idCbo_FlujoDeCobranzas || '',
        Numero: '',
        idCbo_Acciones: '',
        Fecha: false,
        Valor: false,
        Dias: '',
        idMensajesMassend: ''
    });

    const handleAbrirForm = () => {
        setFormData({
            idCbo_AccionesCobranzas: '',
            sCbo_FlujoDeCobranzas: estrategiaSeleccionada?.sCbo_FlujoDeCobranzas || '',
            idCbo_FlujoDeCobranzas: estrategiaSeleccionada?.idCbo_FlujoDeCobranzas || '',
            Numero: '',
            idCbo_Acciones: '',
            Fecha: false,
            Valor: false,
            Dias: '',
            idMensajesMassend: ''
        });
        setErrores({});
        setEditingId(null);
        setShowForm(true);
    };

    useEffect(() => {
        if (showForm) {
            fetchAcciones();
            fetchMensajes();
        }
    }, [showForm]);

    const handleEditarAccion = (item) => {
        setFormData({
            ...item,
            Fecha: item.Fecha === 1 || item.Fecha === true ? true : false,
            Valor: item.Valor === 1 || item.Valor === true ? true : false,
            Dias: item.Dias || '',
            idMensajesMassend: item.idMensajesMassend || '',
            sCbo_FlujoDeCobranzas: item.sCbo_FlujoDeCobranzas || ''
        });
        setEditingId(item.idCbo_AccionesCobranzas || item.id);
        setShowForm(true);
    };

    const handleGuardarAccion = () => {
        const nuevosErrores = {};

        // Validar Tipo de Acción
        if (!formData.idCbo_Acciones) {
            nuevosErrores.idCbo_Acciones = 'El Tipo de Acción es obligatorio';
        }

        // Validar Número de Acción
        if (!formData.Numero) {
            nuevosErrores.Numero = 'El Número de Acción es obligatorio';
        } else if (parseInt(formData.Numero) < 1) {
            nuevosErrores.Numero = 'El Número de Acción no puede ser menor a 1';
        }

        // Validar Código (obligatorio si es SMS)
        if (isAccionSMS() && !formData.idMensajesMassend) {
            nuevosErrores.idMensajesMassend = 'El Mensaje es obligatorio para SMS';
        }

        if (Object.keys(nuevosErrores).length > 0) {
            setErrores(nuevosErrores);
            return;
        }

        setErrores({});

        // Preparar datos según si es nuevo o edición
        const datosAEnviar = {
            idCbo_FlujoDeCobranzas: parseInt(formData.idCbo_FlujoDeCobranzas) || 0,
            sCbo_FlujoDeCobranzas: formData.sCbo_FlujoDeCobranzas || '',
            Numero: parseInt(formData.Numero) || 0,
            idCbo_Acciones: parseInt(formData.idCbo_Acciones) || 0,
            Fecha: formData.Fecha,
            Valor: formData.Valor,
            Dias: parseInt(formData.Dias) || 0,
            idMensajesMassend: parseInt(formData.idMensajesMassend) || 0
        };
        if (editingId) {
          
            datosAEnviar.idCbo_AccionesCobranzas = editingId;
            datosAEnviar.sCbo_FlujoDeCobranzas = formData.sCbo_FlujoDeCobranzas;
            onEditar(datosAEnviar);
        } else {
            onAgregar(datosAEnviar);
        }
        setShowForm(false);
    };

    const fetchAcciones = async () => {
        try {
            const response = await axios.get(APIURL.getcbo_acciones_all());
            setAccionesDisponibles(response.data);
        }
        catch (error) {
            console.error('Error al obtener acciones:', error);
            setAccionesDisponibles([]);
        }
    };

    const fetchMensajes = async () => {
        try {
            const response = await axios.get(APIURL.getMensajesMassend());
            setMensajesDisponibles(response.data);
        }
        catch (error) {
            console.error('Error al obtener mensajes:', error);
            setMensajesDisponibles([]);
        }
    };

    const getInternoExternoLabel = (value) => {
        return value === 1 ? 'INTERNO' : value === 2 ? 'EXTERNO' : '';
    };

    const getTipoLabel = (value) => {
        return value === 1 ? 'TELEFONICO' : value === 2 ? 'TERRENO' : value === 3 ? 'TELEMATICO' : '';
    };

    const getAccionLabel = (idCbo) => {
        const accion = accionesDisponibles.find(a => a.idCbo_Acciones === idCbo);
        if (accion) {
            return `${accion.Accion} - ${getInternoExternoLabel(accion.InternoExterno)} - ${getTipoLabel(accion.Tipo)}`;
        }
        return idCbo || '-';
    };

    const isAccionSMS = () => {
        const accion = accionesDisponibles.find(a => a.idCbo_Acciones == formData.idCbo_Acciones);
        return accion && accion.Accion === 'SMS';
    };

    const getMensajeLabel = (idMensaje) => {
        const mensaje = mensajesDisponibles.find(m => m.idMensajesMassend == idMensaje);
        if (mensaje) {
            return `${mensaje.codigo} - ${mensaje.Mensaje}`;
        }
        return idMensaje || '-';
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        // Si es una fecha ISO, extraer solo la fecha
        const dateStr = typeof fecha === 'string' ? fecha.split('T')[0] : fecha;
        const date = new Date(dateStr);
        return new Intl.DateTimeFormat('es-ES', { year: 'numeric', month: 'long' }).format(date);
    };


    return (
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
            {/* Header */}
            <div className="px-6 py-5 bg-gradient-to-r from-emerald-700 via-emerald-600 to-teal-500 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-white/20 rounded-lg">
                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                    </div>
                    <div>
                        <h2 className="text-lg font-black text-white">Acciones de Cobranza</h2>
                        {estrategiaSeleccionada ? (
                            <div className="flex items-center gap-4 bg-emerald-900/20 px-4 py-2 rounded-lg text-emerald-100 text-xs font-semibold">
                                <span className="flex items-center gap-1">📅 {formatearFecha(estrategiaSeleccionada.Periodo)}</span>
                                <span className="text-emerald-400">•</span>
                                <span className="flex items-center gap-1">📌 {acciones.length} acciones</span>
                                {estrategiaSeleccionada.cbo_ResultadoGestion?.Resultado && (
                                    <>
                                        <span className="text-emerald-400">•</span>
                                        <span className="flex items-center gap-1">📊 {estrategiaSeleccionada.cbo_ResultadoGestion.Resultado}</span>
                                    </>
                                )}
                                {estrategiaSeleccionada.cbo_TipoCartera?.Cartera && (
                                    <>
                                        <span className="text-emerald-400">•</span>
                                        <span className="flex items-center gap-1">💼 {estrategiaSeleccionada.cbo_TipoCartera.Cartera}</span>
                                    </>
                                )}
                                {estrategiaSeleccionada.cbo_Riesgo?.Riesgo && (
                                    <>
                                        <span className="text-emerald-400">•</span>
                                        <span className="flex items-center gap-1">⚠️ {estrategiaSeleccionada.cbo_Riesgo.Riesgo}</span>
                                    </>
                                )}
                            </div>
                        ) : (
                            <p className="text-emerald-100 text-xs">👆 Selecciona una estrategia</p>
                        )}
                    </div>
                </div>
                <button
                    onClick={handleAbrirForm}
                    disabled={!estrategiaSeleccionada}
                    className={`px-3 py-2 font-bold rounded-lg transition-colors flex items-center gap-2 text-sm ${estrategiaSeleccionada
                        ? 'bg-white/20 hover:bg-white/30 text-white'
                        : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                >
                    <PlusIcon className="w-4 h-4" />
                    Agregar
                </button>
            </div>

            {showForm && (
                <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl">
                        <div className="bg-gradient-to-r from-green-700 via-green-600 to-emerald-600 px-6 py-5 flex items-center gap-6">
                            {/* Sección izquierda: Título + Acción */}
                            <div className="flex flex-col gap-1 flex-shrink-0">
                                <h2 className="text-2xl font-bold text-white">
                                    {editingId ? 'Editar Acción' : 'Nueva Acción de Cobranza'}
                                </h2>
                                {(formData.idCbo_Acciones && editingId) ? (
                                    <p className="text-xs text-emerald-100 font-medium">
                                        {getAccionLabel(formData.idCbo_Acciones)}
                                    </p>
                                ) : null}
                            </div>

                            {/* Sección central: Información extendida (flexible) */}
                            <div className="flex-1 flex items-center gap-3 bg-emerald-900/30 px-4 py-2 rounded-lg text-emerald-100 text-xs font-semibold flex-wrap">
                                <span className="flex items-center gap-1 whitespace-nowrap uppercase">📅 {formatearFecha(estrategiaSeleccionada.Periodo)}</span>
                                {estrategiaSeleccionada.cbo_ResultadoGestion?.Resultado && (
                                    <>
                                        <span className="flex items-center gap-1 whitespace-nowrap">📊 {estrategiaSeleccionada.cbo_ResultadoGestion.Resultado}</span>
                                    </>
                                )}
                                {estrategiaSeleccionada.cbo_TipoCartera?.Cartera && (
                                    <>
                                        <span className="flex items-center gap-1 whitespace-nowrap">💼 {estrategiaSeleccionada.cbo_TipoCartera.Cartera}</span>
                                    </>
                                )}
                                {estrategiaSeleccionada.cbo_Riesgo?.Riesgo && (
                                    <>
                                        <span className="flex items-center gap-1 whitespace-nowrap">⚠️ {estrategiaSeleccionada.cbo_Riesgo.Riesgo}</span>
                                    </>
                                )}
                            </div>

                            {/* Botón cerrar */}
                            <button
                                onClick={() => setShowForm(false)}
                                className="p-2 hover:bg-white/20 rounded-lg transition-colors flex-shrink-0"
                            >
                                <XMarkIcon className="w-6 h-6 text-white" />
                            </button>
                        </div>

                        <div className="p-6 space-y-4">
                            {/* Mostrar errores si existen */}
                            {Object.values(errores).filter(error => error).length > 0 && (
                                <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
                                    <div className="flex items-start gap-3">
                                        <svg className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                        </svg>
                                        <div className="flex-1">
                                            <h3 className="text-sm font-semibold text-red-800 mb-1">Por favor, revisa los siguientes errores:</h3>
                                            <ul className="text-sm text-red-700 space-y-1">
                                                {Object.values(errores).filter(error => error).map((error, index) => (
                                                    <li key={index} className="flex items-center gap-2">
                                                        <span className="w-1.5 h-1.5 bg-red-500 rounded-full"></span>
                                                        {error}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div>
                                <label className="block text-sm font-semibold text-gray-700 mb-2">
                                    Tipo de Acción *
                                </label>
                                <select
                                    value={formData.idCbo_Acciones}
                                    onChange={(e) => {
                                        setFormData({ ...formData, idCbo_Acciones: e.target.value });
                                        setErrores({ ...errores, idCbo_Acciones: '' });
                                    }}
                                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${errores.idCbo_Acciones ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                        }`}
                                >
                                    <option value="">Selecciona una acción...</option>
                                    {accionesDisponibles.map((accion) => (
                                        <option key={accion.idCbo_Acciones} value={accion.idCbo_Acciones}>
                                            {accion.Accion} - {getInternoExternoLabel(accion.InternoExterno)} - {getTipoLabel(accion.Tipo)}
                                        </option>
                                    ))}
                                </select>
                                {errores.idCbo_Acciones && (
                                    <p className="text-red-600 text-xs mt-1">{errores.idCbo_Acciones}</p>
                                )}
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Número de Acción *
                                    </label>
                                    <input
                                        type="number"
                                        value={formData.Numero}
                                        onChange={(e) => {
                                            setFormData({ ...formData, Numero: e.target.value });
                                            setErrores({ ...errores, Numero: '' });
                                        }}
                                        placeholder="Ej: 1, 2, 3..."
                                        min="1"
                                        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${errores.Numero ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                            }`}
                                    />
                                    {errores.Numero && (
                                        <p className="text-red-600 text-xs mt-1">{errores.Numero}</p>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Días (para próxima acción)
                                    </label>
                                    <input
                                        type="number"
                                        value={formData.Dias}
                                        onChange={(e) => setFormData({ ...formData, Dias: e.target.value })}
                                        placeholder="Ej: 3, 7, 30..."
                                        min="0"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                                    />
                                </div>

                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Código {isAccionSMS() && <span className="text-red-600">*</span>}
                                    </label>
                                    {isAccionSMS() ? (
                                        <>
                                            <select
                                                value={formData.idMensajesMassend}
                                                onChange={(e) => {
                                                    setFormData({ ...formData, idMensajesMassend: e.target.value });
                                                    setErrores({ ...errores, idMensajesMassend: '' });
                                                }}
                                                className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${errores.idMensajesMassend ? 'border-red-500 bg-red-50' : 'border-gray-300'
                                                    }`}
                                            >
                                                <option value="">Selecciona un mensaje...</option>
                                                {mensajesDisponibles.map((mensaje) => (
                                                    <option key={mensaje.idMensajesMassend} value={mensaje.idMensajesMassend}>
                                                        {mensaje.codigo} - {mensaje.Mensaje.substring(0, 50)}...
                                                    </option>
                                                ))}
                                            </select>
                                            {errores.idMensajesMassend && (
                                                <p className="text-red-600 text-xs mt-1">{errores.idMensajesMassend}</p>
                                            )}
                                        </>
                                    ) : (
                                        <input
                                            type="text"
                                            value={formData.idMensajesMassend}
                                            disabled
                                            placeholder="Solo para SMS"
                                            className="w-full px-4 py-2 border border-gray-200 bg-gray-100 text-gray-500 cursor-not-allowed rounded-lg"
                                        />
                                    )}
                                </div>

                                <div className="flex flex-col justify-between">
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Opciones
                                    </label>
                                    <div className="flex items-center gap-4">
                                        <label className="flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={formData.Fecha}
                                                onChange={(e) => setFormData({ ...formData, Fecha: e.target.checked })}
                                                className="w-4 h-4 text-green-600 rounded focus:ring-2 focus:ring-green-500"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">¿Registra Fecha?</span>
                                        </label>
                                        <label className="flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={formData.Valor}
                                                onChange={(e) => setFormData({ ...formData, Valor: e.target.checked })}
                                                className="w-4 h-4 text-green-600 rounded focus:ring-2 focus:ring-green-500"
                                            />
                                            <span className="ml-2 text-sm text-gray-700">¿Registra Valor?</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gray-100 px-6 py-4 flex items-center justify-end gap-3 border-t border-gray-200 rounded-b-2xl">
                            <button
                                onClick={() => setShowForm(false)}
                                className="px-6 py-2.5 bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold rounded-lg transition-all"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleGuardarAccion}
                                className="px-6 py-2.5 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold rounded-lg transition-all flex items-center gap-2"
                            >
                                <CheckIcon className="w-5 h-5" />
                                  {editingId ? 'Actualizar' : 'Guardar'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {!estrategiaSeleccionada ? (
                <div className="p-12 text-center">
                    <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 15l-2 5m0 0l-2-5m2 5v-7a2 2 0 00-2-2H6a2 2 0 00-2 2v7" />
                    </svg>
                    <h3 className="text-lg font-bold text-gray-700">Selecciona una estrategia</h3>
                    <p className="text-gray-500 text-sm mt-2">Elige una estrategia para agregar acciones de cobranza</p>
                </div>
            ) : acciones.length === 0 ? (
                <div className="p-12 text-center">
                    <svg className="w-16 h-16 text-gray-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6v6m0 0v6m0-6h6m0 0h6m0 0v6m0 0v6m0 0h-6m0 0h-6" />
                    </svg>
                    <h3 className="text-lg font-bold text-gray-700">No hay acciones</h3>
                    <p className="text-gray-500 text-sm mt-2">Agrega la primera acción de cobranza para esta estrategia</p>
                </div>
            ) : (
                <div className="overflow-x-auto max-h-[calc(100vh-300px)] overflow-y-auto">
                    <table className="w-full">
                        <thead className="sticky top-0 z-10">
                            <tr className="bg-gradient-to-r from-emerald-50 to-teal-50 border-b-2 border-emerald-200">
                                <th className="px-4 py-3 text-left text-xs font-black text-emerald-900 uppercase tracking-wider"># </th>
                                <th className="px-4 py-3 text-left text-xs font-black text-emerald-900 uppercase tracking-wider">N° Acción</th>
                                <th className="px-4 py-3 text-left text-xs font-black text-emerald-900 uppercase tracking-wider">Tipo Acción</th>
                                <th className="px-4 py-3 text-left text-xs font-black text-emerald-900 uppercase tracking-wider">Código</th>
                                <th className="px-4 py-3 text-center text-xs font-black text-emerald-900 uppercase tracking-wider">Días</th>
                                <th className="px-4 py-3 text-center text-xs font-black text-emerald-900 uppercase tracking-wider">Fecha</th>
                                <th className="px-4 py-3 text-center text-xs font-black text-emerald-900 uppercase tracking-wider">Valor</th>
                                <th className="px-4 py-3 text-center text-xs font-black text-emerald-900 uppercase tracking-wider">⚙️</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {acciones.map((item, index) => (
                                <tr key={item.id} className={`hover:bg-emerald-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                                    <td className="px-4 py-3 text-sm font-bold text-gray-900">{index + 1}</td>
                                    <td className="px-4 py-3 text-sm font-bold text-gray-900">{item.Numero}</td>
                                    <td className="px-4 py-3 text-sm text-gray-700">
                                        <code className="bg-gray-100 px-2 py-1 rounded text-xs font-mono">
                                            {item.idCbo_Acciones ? getAccionLabel(item.idCbo_Acciones) : '-'}
                                        </code>
                                    </td>

                                    <td className="px-4 py-3 text-sm font-medium text-gray-700">
                                        <code className="bg-gray-100 px-2 py-1 rounded text-xs font-mono">
                                            {item.idMensajesMassend ? getMensajeLabel(item.idMensajesMassend) : '-'}
                                        </code>
                                    </td>

                                    <td className="px-4 py-3 text-center text-sm text-gray-700 font-medium">
                                        {item.Dias ? `${item.Dias}d` : '-'}
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        <span className={`inline-flex items-center justify-center px-2.5 py-1 rounded-lg text-xs font-bold ${item.Fecha ? 'bg-blue-100 text-blue-700' : 'bg-gray-200 text-gray-600'
                                            }`}>
                                            {item.Fecha ? '✓' : '-'}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        <span className={`inline-flex items-center justify-center px-2.5 py-1 rounded-lg text-xs font-bold ${item.Valor ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-600'
                                            }`}>
                                            {item.Valor ? '✓' : '-'}
                                        </span>
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        <div className="flex items-center justify-center gap-1">
                                            <button
                                                onClick={() => handleEditarAccion(item)}
                                                className="p-1.5 hover:bg-blue-100 rounded-lg transition-colors group"
                                                title="Editar acción"
                                            >
                                                <PencilIcon className="w-4 h-4 text-blue-600" />
                                            </button>
                                            <button
                                                onClick={() => onEliminar(item)}
                                                className="p-1.5 hover:bg-red-100 rounded-lg transition-colors group"
                                                title="Eliminar acción"
                                            >
                                                <TrashIcon className="w-4 h-4 text-red-600" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
